export default "__VITE_ASSET__DxOp3sbm__"